import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { withData } from '../utility/DataContext';


const styles = theme => ({
  loading: {
    width: '100%',
    paddingTop: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 4
  },
  slide: {
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'auto',
  },
  image: {
    height: 180,
    borderRadius: 10,
    marginRight: theme.spacing.unit * 2,
    boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.5)',
    marginBottom: theme.spacing.unit
  },
});


class MemeShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      loaded: false,
      loadCount: 0,
      amount: -1,
      overlayLeft: false,
      overlayRight: true,
    };
    this.amount = 10;
  }

  componentDidMount() {
    this.updateData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.loaded && this.state.loadCount === this.state.amount){
      this.setState({loaded: true});
    }
  }

  updateData = () => {
    const ref = this.props.data.firestore.collection('memes').orderBy('date', 'desc').limit(this.amount);
    ref.get().then(querySnapshot => {
      this.setState({
        amount: querySnapshot.size, 
        },
        () => {
          querySnapshot.forEach(doc => {
            let data = doc.data();
            data.key = doc.id;
            this.setState(prevState => {
              return {
                images: [...prevState.images, data],
                loadCount: prevState.loadCount + 1,
              };
            });
          });
        }
      );
    });
  }

  handleScroll = event => {
    const div = event.target;
    const overlayLeft = div.scrollLeft !== 0;
    const overlayRight = div.scrollWidth - div.scrollLeft !== div.offsetWidth;
    this.setState({overlayLeft, overlayRight});
  }

  render() {
    const {classes} = this.props;
    const left = this.state.overlayLeft ? 0.3 : 1.0;
    const right = this.state.overlayRight ? 0.3 : 1.0;
    const gradient = `linear-gradient(to right, rgba(0,0,0,${left}) 0%, rgba(0,0,0,1.0) 10%, rgba(0,0,0,1.0) 90%, rgba(0,0,0,${right}) 100%, transparent)`;
    return (
      <div  className={classes.root} style={{WebkitMaskImage: gradient}}>
        {this.state.loaded ? 
          <div className={classes.slide} onScroll={this.handleScroll}>
          {
            this.state.images.map(image => {
              return <img src={image.url} alt={image.key} key={image.key} className={classes.image} />
            })
          }
          </div>
        :
          <Grid container justify="center" alignItems="center" className={classes.loading}>
            <CircularProgress color="primary" size={150} thickness={1.5} />
          </Grid>
        }
      </div>
    );
  }
}

export default withData(withStyles(styles)(MemeShow));


// WEBPACK FOOTER //
// ./src/components/MemeShow.js